module.exports = __webpack_public_path__ + "static/img/list-img0.4c34901.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list-img0.png
// module id = fPD8
// module chunks = 0